import React, { useEffect, useState } from "react";
import Popupimg from "./assets/popup.jpeg";
import "./popup.css";

function Popup() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    setShowPopup(true);
  }, []);

  return (
    <>
      {showPopup && (
        <div className="row">
          <div className="col-12">
            <div className="popup-overlay">
              <div className="popup-box">
                <button
                  className="popup-close"
                  onClick={() => setShowPopup(false)}
                >
                  ×
                </button>
                <div className="col-lg-6">
                  <div className="popupimg">
                    <img src={Popupimg} alt="MI Trading" className="" />
                  </div>
                  {/* <button
                    className="popup-button"
                    onClick={() => setShowPopup(false)}
                  >
                    Close
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Popup;